import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Libs
import { HELP_PAGE_KEY } from '@/api/fetchHelpPage'
import { helpTermsPath, legalDocPath } from '../../methods'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

export const LEGAL_DOCS = [
  { key: HELP_PAGE_KEY.USER_TERMS, label: 'Help_Center_Legal_User_Terms' },
  { key: HELP_PAGE_KEY.PRIVACY_POLICY, label: 'Help_Center_Legal_Privacy_Policy' },
  { key: HELP_PAGE_KEY.LEGAL_DISCLAIMER, label: 'Help_Center_Legal_Disclaimer' },
] as const

type Props = {
  countryQuery?: string
}

/** 幫助中心頁尾：條款與政策連結 */
const LegalLinks = ({ countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <nav className={cx('help-legal-links')} aria-label={t('Help_Center_Legal_Title')}>
      <Link href={helpTermsPath(countryQuery)}>{t('Help_Center_Legal_Title')}</Link>
      {LEGAL_DOCS.map((doc) => (
        <Link key={doc.key} href={legalDocPath(doc.key, countryQuery)}>
          {t(doc.label)}
        </Link>
      ))}
    </nav>
  )
}

export default LegalLinks
